import {
  TextField,
  Box,
  Grid,
  Typography,
  useTheme,
  FormControl,
  FormLabel,
  Button,
  IconButton,
  Stack,
  FormControlLabel,
  Tooltip,
  Checkbox,
  InputLabel,
  Select,
  MenuItem,
  Breadcrumbs,
  LinearProgress,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Hidden,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { nanoid } from "@reduxjs/toolkit";
import AddIcon from "@mui/icons-material/Add";
import {
  GridActionsCellItem,
  DataGrid,
  GridRowModes,
  GridToolbarContainer,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import useMediaQuery from "@mui/material/useMediaQuery";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import { Formik } from "formik";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import {
  getFetchData,
  postData,
  requestMail,
} from "../../../store/reducers/Formapireducer";
import React, { useState, useEffect, useRef } from "react";
import { LoadingButton } from "@mui/lab";
import Swal from "sweetalert2";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { tokens } from "../../../Theme";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {
  CheckinAutocomplete,
  Employeeautocomplete,
  ManagerTaskEmpAutocomplete,
  MultiFormikOptimizedAutocomplete,
  Productautocomplete,
  SprintEmpAutocomplete,
} from "../../../ui-components/global/Autocomplete";
import {
  dataGridHeaderFooterHeight,
  dataGridRowHeight,
  formGap,
} from "../../../ui-components/global/utils";
//import Productautocomplete from "../../../ui-components/global/Autocomplete";
import FileListPopup from "../../../ui-components/FIleViewDialog";
import FileUploadIconButton from "../../../ui-components/FileUploadButton";
import { attachmentPost } from "../../../store/reducers/LoginReducer";
import GradingIcon from "@mui/icons-material/Grading";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import axios from "axios";
import store from "../../..";
// import ErrorMsgData from "../../Security/validationMsg.json"
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import * as Yup from "yup";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { getConfig } from "../../../config";
// const validationSchema = Yup.object().shape({
//   TargetDate: Yup.string().required(ErrorMsgData.Managertask.TargetDate).nullable(),
//   date: Yup.string().required(ErrorMsgData.Managertask.date),
//   TaskType: Yup.string().required(ErrorMsgData.Managertask.TaskType),
//   TaskPriority: Yup.string().required(ErrorMsgData.Managertask.TaskPriority),
//   Comment: Yup.string().required(ErrorMsgData.Managertask.Comment),
// });

const EditDailytaskListEdit = () => {

  const config = getConfig();
  const baseurl1 = config.BASE_URL;
  console.log(baseurl1, "url path");

  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  let params = useParams();
  const dispatch = useDispatch();
  var recID = params.id;
  var compID = sessionStorage.getItem("companyId");
  var CompId = compID;
  var QA = sessionStorage.getItem("qualityassurance");
  var mode = params.Mode;
  const data = useSelector((state) => state.formApi.Data);
  const Status = useSelector((state) => state.formApi.Status);
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const Msg = useSelector((state) => state.formApi.msg);
  const loading = useSelector((state) => state.formApi.getLoading);
  const isLoading = useSelector((state) => state.formApi.postLoading);
  const getLoading = useSelector((state) => state.formApi.getLoading);
  const exploreLoading = useSelector((state) => state.exploreApi.loading);
  const [open, setOpen] = useState(false);
  const [files, setFiles] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const rowSx = { height: 36, "& td, & th": { py: 0.5 } };
  const YearFlag = sessionStorage.getItem("YearFlag");
  const EMPID = sessionStorage.getItem("EmpId");
  const Year = sessionStorage.getItem("year");
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const location = useLocation();
  const rowData = location.state || {};
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);


  const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
  const is003Subscription = SubscriptionCode.endsWith("003");
  console.log(SubscriptionCode, is003Subscription, "SubscriptionCode");



  const [showImage, setShowImage] = useState(
    params.Mode == "IM" ? true : false,
  );
  const [errorMsgData, setErrorMsgData] = useState(null);
  const [validationSchema, setValidationSchema] = useState(null);
  //FOR ADDITONAL DROPDOWNS
  const [showMore, setShowMore] = React.useState(false);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);
        const schema = Yup.object().shape({
          ProName: Yup.object().required(data.Managertask.ProName).nullable(),
          empName: Yup.object().required(data.Managertask.empName).nullable(),
          TargetDate: Yup.string()
            .required(data.Managertask.TargetDate)
            .nullable(),
          date: Yup.string().required(data.Managertask.date),
          TaskType: Yup.string().required(data.Managertask.TaskType),
          description: Yup.string().required(data.Managertask.description),
          TaskPriority: Yup.string().required(data.Managertask.TaskPriority),
          Comment: Yup.string().required(data.Managertask.Comment),
          estimatedHours: Yup.string().required(
            data.Managertask.estimatedHours,
          ),
        });

        setValidationSchema(schema);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, []);

  useEffect(() => {
    dispatch(getFetchData({ accessID: "TR132", get: "get", recID })).then(
      (res) => {
        console.log(
          "🚀 ~ EditDailytaskListEdit ~ res:",
          res.payload.Data.EmployeesID,
        );
        var url = store.getState().globalurl.empGetAttachmentUrl;
        axios
          .get(url, {
            params: {
              empId: res.payload.Data.EmployeesID,
              appId: recID,
            },
          })
          .then((response) => {
            setFiles(response.data);
          })
          .catch((err) => {
            setError("Failed to fetch attachments.");
            console.error(err);
          })
          .finally(() => setLoading(false));
      },
    );
  }, []);


  const targettoday = new Date().toISOString().split("T")[0];

  const today = new Date();
  const dd = String(today.getDate()).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0"); // January is 0
  const yyyy = today.getFullYear();

  const getCurrentDate = () => {
    const today = new Date();
    return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(
      2,
      "0",
    )}-${String(today.getDate()).padStart(2, "0")}`;
  };
  console.log(mode, "mode");
  const assigneddDate = `${yyyy}-${mm}-${dd}`;
  const EmpName = sessionStorage.getItem("EmpName");
  const dailyTaskInitialValue = {
    code: "0",
    description: data.Name,
    date: mode === "A" ? getCurrentDate() : data.TaskDate, // Ensures initial date follows DD-MM-YYYY
    status: mode === "A" ? "AS" : data.Status,
    Comment: data.Comments,
    sortOrder: data.SortOrder,
    disable: data.Disable === "Y",
    ProName: data.ProjectID
      ? { RecordID: data.ProjectID, Name: data.ProjectName }
      : null,
    estimatedHours: data.Estimatehourse,
    actualHours: mode === "A" ? 0 : data.ActualHourse,
    empDate:
      mode === "A" || mode === "TO" ? getCurrentDate() : data.TransferDate,
    employee: data.ToEmployeeID
      ? { RecordID: data.ToEmployeeID, Name: data.ToEmployeeName }
      : null,
    empCode: data.EmployeeCode,
    empName: data.EmployeesID
      ? { RecordID: data.EmployeesID, Name: data.EmployeeName }
      : null,
    // empName: data.EmployeesID
    //   ? { EmpID: data.EmployeesID, Name: data.EmployeeName }
    //   : null,

    // assignedDate:
    //   mode === "A" || mode === "TO" ? getCurrentDate() : mode === "S" || data.TaskSource === "Self" ? data.TaskDate : data.AssignedDate,
    assignedDate:
      mode === "A" || mode === "TO" ? getCurrentDate() : data.AssignedDate,
    assignedPerson:
      mode === "A" || mode === "TO"
        ? EmpName
        : mode === "S"
          ? data.EmployeeName
          : data.AssignedPerson,
    AssignedBy: mode === "A" || mode === "S" ? EMPID : data.AssignedBy,
    ManagerComments: data.ManagerComments ? data.ManagerComments : "",
    TaskPriority: data.TaskPriority,
    TargetDate: data.TargetDate,
    TaskType:
      data.TaskType == "Normal"
        ? "Normal"
        : data.TaskType == "Learning&development"
          ? "Learning&development"
          : data.TaskType == "Research&development"
            ? "Research&development"
            : data.TaskType == "Bug"
              ? "Bug"
              : data.TaskType == "Improvements"
                ? "Improvements"
                : data.TaskType == "Up-skill"
                  ? "Up-skill"
                  : "",
    Milestone: data.MilestonesID
      ? { RecordID: data.MilestonesID, Name: data.MilestonesName }
      : null,
    OperationStage:
      data.OperationstageID && data.OperationstageID !== "0"
        ? { RecordID: data.OperationstageID, Name: data.OperationstageName }
        : null,
    Activities:
      data.ActivityID && data.ActivityID !== "0"
        ? { RecordID: data.ActivityID, Name: data.ActivityName }
        : null,
  };

  const DTSaveFn = async (values) => {
    let action = mode === "A" ? "insert" : "update";
    const isCheck = values.disable ? "Y" : "N";

    const idata = {
      parentID: values.empName?.RecordID,
      // parentID: values.empName?.EmpID,
      RecordID: recID,
      Code: "0",
      Name: values.description,
      TaskDate: values.date,
      // Estimatehourse: values.estimatedHours || data.Estimatehourse,
      // ActualHourse: values.actualHours || data.ActualHourse,
      Estimatehourse: values.estimatedHours || 0,
      ActualHourse: values.actualHours,
      Status: mode == "TO" ? "T" : values.status,
      Comments: values.Comment.replace(/\s+/g, " ").trim(),
      SortOrder: "0",
      Disable: isCheck,
      EmpDate: values.empDate,
      FromEmployeeID: EMPID,
      EmployeesID: values.empName?.RecordID,
      ManagerComments: values.ManagerComments,
      EmployeeName: values.empName.Name,
      ToEmployeeID: values?.employee?.RecordID || data.ToEmployeeID || 0,
      TransferDate: values.empDate || "",
      FunctionsID: 0,
      ProjectID: values.ProName?.RecordID || 0,
      ProjectName: values.ProName.Name || "",
      AssignedBy: values.AssignedBy || 0,
      AssignedDate: values.assignedDate || "",
      TaskPriority: values.TaskPriority ? values.TaskPriority : "",
      TargetDate: values.TargetDate ? values.TargetDate : data.TaskDate,
      TaskType: values.TaskType ? values.TaskType : "",
      ...(mode == "TO" && { Source: "Manager" }),
      ApprovedBy: EMPID,
      ActivityID: values.Activities?.RecordID || 0,
      ActivityName: values.Activities?.Name || "",
      OperationstageID: values.OperationStage?.RecordID || 0,
      OperationstageName: values.OperationStage?.Name || "",
      MilestonesID: values.Milestone?.RecordID || 0,
      MilestonesName: values.Milestone?.Name || "",
      Lat: "",
      Lng: "",
      Outofboundary: ""
    };
    console.log(values.empName, "values.empName?.EmpID");
    const response = await dispatch(
      postData({ accessID: "TR132", action, idata }),
    );
    if (response.payload.Status === "Y") {
      if (
        (values.status === "AS" ||
          values.status === "C" ||
          values.status === "AP" ||
          values.status === "B") &&
        mode !== "TO"
      ) {
        dispatch(
          requestMail({
            EmployeeID: EMPID,
            Type: "DT",
            RecordID: response.payload.Recid,
          }),
        );
      }
      toast.success(response.payload.Msg);
      // if (mode == "A") {

      //   navigate(`/Apps/Secondarylistview/TR263/Tasks/${EMPID}`);

      // }
      navigate(-1);
    } else {
      toast.error(response.payload.Msg);
    }
  };

  const fnLogOut = (props) => {
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") {
          navigate("/");
        }
        if (props === "Close") {
          navigate(-1);
        }
      } else {
        return;
      }
    });
  };

  async function fileUpload(file, EmpId, action, id, purpose) {
    if (!EmpId) {
      toast.error("Please choose Personnel");
      return;
    }
    const formData = new FormData();
    formData.append("file", file);
    formData.append("empId", EmpId);
    formData.append("appId", data.RecordID);
    formData.append("type", "T");
    formData.append("source", "Manager");
    formData.append("action", action);
    formData.append("id", id);
    formData.append("purpose", purpose);
    const respose = await dispatch(attachmentPost({ data: formData }));

    if (respose.payload.success) {
      toast.success(respose.payload.message);
      var url = store.getState().globalurl.empGetAttachmentUrl;
      axios
        .get(url, {
          params: {
            empId: EmpId,
            appId: recID,
          },
        })
        .then((response) => {
          setFiles(response.data);
        })
        .catch((err) => {
          setError("Failed to fetch attachments.");
          console.error(err);
        })
        .finally(() => setLoading(false));
    } else {
      toast.success(respose.payload.message);
    }
  }


  //---------------------------Time Table Screen ----------START------------>

  const TTrows = [
    {
      id: 1,
      RecordID: 1,
      Days: { RecordID: 1, Name: "Monday" },
      Department: { RecordID: 1, Name: "Maths" },
      Slots: { RecordID: 1, Name: "Slot 1" },
      Comments: "Morning",
    },
    {
      id: 2,
      RecordID: 2,
      Days: { RecordID: 2, Name: "Tuesday" },
      Department: { RecordID: 2, Name: "Science" },
      Slots: { RecordID: 3, Name: "Slot 3" },
      Comments: "Middle",
    },
    {
      id: 3,
      RecordID: 3,
      Days: { RecordID: 3, Name: "Wednesday" },
      Department: { RecordID: 4, Name: "English" },
      Slots: { RecordID: 4, Name: "Slot 4" },
      Comments: "Afternoon",
    },
  ];

  const [show, setScreen] = React.useState("0");
  const [pageSize, setPageSize] = useState(15);
  const [page, setPage] = React.useState(0);
  const [rows, setRows] = React.useState(TTrows);

  useEffect(() => {
    if (is003Subscription) {
      setScreen("0"); // default to Task (Explore enabled)
    } else {
      setScreen("0"); // force Task only
    }
  }, [is003Subscription]);

  const [rowModesModel, setRowModesModel] = React.useState({});
  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };
  const handleEditClick = (RecordID) => () => {
    setRowModesModel({
      ...rowModesModel,
      [RecordID]: { mode: GridRowModes.Edit },
    });
  };

  const handleSaveClick = (RecordID) => () => {
    setRowModesModel({
      ...rowModesModel,
      [RecordID]: { mode: GridRowModes.View },
    });
  };

  // const handleDeleteClick = (RecordID) => async () => {

  //   // Remove row from UI
  //   setRows((prev) =>
  //     prev.filter((row) => row.RecordID !== RecordID)
  //   );

  //   // 🔴 Only call API if RecordID is number
  //   if (!RecordID || isNaN(Number(RecordID))) {
  //     console.log("Temporary row deleted locally only");
  //     return;
  //   }

  //   try {
  //     const response = await dispatch(
  //       postData({
  //         accessid: "tr340",
  //         action: "harddelete",
  //         data: {
  //           RecordID: Number(RecordID),
  //         },
  //       })
  //     );

  //     if (response.payload?.Status === "Y") {
  //       toast.success(response.payload.Msg);
  //     } else {
  //       toast.error(response.payload?.Msg);
  //     }

  //   } catch (error) {
  //     toast.error("Delete failed");
  //   }
  // };
  //   const handleDeleteClick = (RecordID) => async () => {
  //     setRows(rows.filter((row) => row.RecordID !== RecordID));
  // console.log("heloooooooooooo");

  //     if (!isNaN(RecordID)) {
  //       const idata = {
  //         RecordID: RecordID,
  //       };

  //       console.log(idata, "--idata");
  //     //  return; 
  //       const response = await dispatch(
  //         postData({
  //           accessID: "tr340",
  //           action: "harddelete",
  //           idata: idata,
  //         }),
  //       );

  //       if (response.payload?.Status === "Y") {
  //         toast.success(response.payload.Msg);

  //       } else {
  //         toast.error(response.payload?.Msg || "Operation failed");
  //       }
  //     }
  //   };

  const handleDeleteClick = (RecordID) => async () => {
    try {
      console.log("Deleting ID:", RecordID, typeof RecordID);

      // ✅ Remove row from UI first
      setRows((prevRows) =>
        prevRows.filter((row) => row.RecordID !== RecordID)
      );

      // ✅ Only call API if RecordID is numeric
      if (!RecordID || isNaN(Number(RecordID))) {
        // console.log("Temporary row deleted locally only");
        toast.success("Deleted Successfully");
        return;
      }


      const response = await dispatch(
        postData({
          accessid: "tr340",   // ⚠ use correct case
          action: "harddelete",
          data: {             // ⚠ use data instead of idata if backend expects data
            RecordID: Number(RecordID),
          },
        })
      );

      if (response?.payload?.Status === "Y") {
        toast.success(response.payload.Msg);
      } else {
        toast.error(response?.payload?.Msg || "Delete failed");
      }

    } catch (error) {
      console.error("Delete Error:", error);
      toast.error("Error occurred while deleting.");
    }
  };

  const handleCancelClick = (RecordID) => () => {
    setRowModesModel({
      ...rowModesModel,
      [RecordID]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row.RecordID === RecordID);
    if (editedRow.isNew) {
      setRows(rows.filter((row) => row.RecordID !== RecordID));
    }
  };


  const processRowUpdate = (newRow, oldRow) => {
    const isNew = !oldRow?.RecordID;
    const updatedRow = { ...newRow, isNew };

    setRows((prev) => {
      const index = prev.findIndex(
        (row) => row.RecordID === updatedRow.RecordID
      );
      if (index !== -1) {
        const newData = [...prev];
        newData[index] = updatedRow;
        return newData;
      }
      return [...prev, updatedRow];
    });
    console.log(updatedRow, "--updatedRow");

    return updatedRow;
  };
  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  function EditDaysAutocompleteCell(props) {
    const { id, value, field, api, row } = props;

    const handleChange = async (newValue) => {
      console.log("🚀 ~ Days  handleChange ~ Days newValue:", newValue);
      if (!newValue) return;

      setDayslookup(newValue);
      await api.setEditCellValue({
        id,
        field: "Days",
        value: newValue,
      });

      api.stopCellEditMode({ id, field });
    };
    const [dayslookup, setDayslookup] = useState(row.Days ? row.Days : null);
    return (
      <SprintEmpAutocomplete
        name="Days"
        label="Days"
        id="Days"
        value={dayslookup}
        onChange={handleChange}
        url={`${listViewurl}?data={"Query":{"AccessID":"2147","ScreenName":"Days","Filter":"","Any":""}}`}
      // url={`https://ess.beyondexs.com/api/wslistview_mysql.php?data={"Query":{"AccessID":"2106","ScreenName":"Scheduled To","Filter":"ERank='${row.Rank}' AND parentID='${CompanyID}'","Any":""}}`}
      />
    );
  }
  const [termsIDPass, setTermsIDPas] = useState(null);

  function EditdeptAutocompleteCell(props) {
    const { id, value, field, api, row } = props;

    const handleChange = async (newValue) => {
      console.log("🚀 ~ Department handleChange ~ Department newValue:", newValue);
      if (!newValue) return;

      setDeptlookup(newValue);
      await api.setEditCellValue({
        id,
        field: "Department",
        value: newValue,
      });

      api.stopCellEditMode({ id, field });
    };
    const [deptlookup, setDeptlookup] = useState(row.Department ? row.Department : null);
    return (
      <SprintEmpAutocomplete
        name="Department"
        label="Department"
        id="Department"
        value={deptlookup}
        onChange={handleChange}
        url={`${listViewurl}?data={"Query":{"AccessID":"2149","ScreenName":"Department","Filter":"parentID=${compID}","Any":""}}`}
      // url={`https://ess.beyondexs.com/api/wslistview_mysql.php?data={"Query":{"AccessID":"2106","ScreenName":"Scheduled To","Filter":"ERank='${row.Rank}' AND parentID='${CompanyID}'","Any":""}}`}
      />
    );
  }
  function EditSlotsAutocompleteCell(props) {
    const { id, value, field, api, row } = props;

    const handleChange = async (newValue) => {
      console.log("🚀 ~ Slots handleChange ~ Slots newValue:", newValue);
      if (!newValue) return;

      setSlotslookup(newValue);
      await api.setEditCellValue({
        id,
        field: "Slots",
        value: newValue,
      });

      api.stopCellEditMode({ id, field });
    };
    const [slotslookup, setSlotslookup] = useState(row.Slots ? row.Slots : null);
    return (
      <SprintEmpAutocomplete
        name="Slots"
        label="Slots"
        id="Slots"
        value={slotslookup}
        onChange={handleChange}
        url={`${listViewurl}?data={"Query":{"AccessID":"2163","ScreenName":"Slots","Filter":"parentID='${termsIDPass}'","Any":""}}`}
      // url={`https://ess.beyondexs.com/api/wslistview_mysql.php?data={"Query":{"AccessID":"2106","ScreenName":"Scheduled To","Filter":"ERank='${row.Rank}' AND parentID='${CompanyID}'","Any":""}}`}
      />
    );
  }

  const TTColumns = [
    {
      field: "RecordID",
      headerName: "Record ID",
      width: 120,
      hide: true,
    },
    {
      field: "Days",
      headerName: "Days",
      headerAlign: "center",
      align: "left",
      width: 100,
      hide: false,
      editable: true,
      sortable: false,
      renderCell: (params) => {
        return params.value?.Name || ""; // show only the name
      },
      renderEditCell: (params) => {
        return <EditDaysAutocompleteCell {...params} />;
      },
      // renderEditCell: (params) => (
      //   <CheckinAutocomplete
      //     name="Days"
      //     value={params.value || null}
      //     url={`${listViewurl}?data=
      // {"Query":{"AccessID":"2147","ScreenName":"Days","Filter":"","Any":"","CompId":""}}`}
      //     onChange={(newValue) => {
      //       params.api.setEditCellValue({
      //         id: params.id,
      //         field: "Days",
      //         value: newValue,
      //       });
      //     }}
      //   />
      // ),
    },
    {
      field: "Department",
      headerName: "Subjects",
      headerAlign: "center",
      width: 260,
      hide: false,
      editable: true,
      sortable: false,
      renderCell: (params) => {
        return params.value?.Name || ""; // show only the name
      },
      renderEditCell: (params) => {
        return <EditdeptAutocompleteCell {...params} />;
      },
    },
    {
      field: "Slots",
      headerName: "Slots",
      width: 200,
      hide: false,
      editable: true,
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => {
        return params.value?.Name || ""; // show only the name
      },
      renderEditCell: (params) => {
        return <EditSlotsAutocompleteCell {...params} />;
      },

    },
    {
      headerName: "Comments",
      field: "Comments",
      width: "320",
      hide: false,
      editable: true,
      headerAlign: "center"
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "actions",
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              material={{
                sx: {
                  color: "primary.main",
                },
              }}
              onClick={handleSaveClick(id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
            />,
          ];
        }

        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
          />,
        ];
      },
    },
  ];


  const TimeTableInitialValue = React.useMemo(() => ({
    ProName: null,
    empName: null,
    empCode: "",
    Terms: null
    // fromdate: "",
    // todate: "",
  }), []);

  const getFirstDateOfMonth = (month) => {
    if (!month) return "";
    return `${month}-01`;
  };

  const getLastDateOfMonth = (month) => {
    if (!month) return "";
    const date = new Date(month + "-01");
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
      .getDate()
      .toString()
      .padStart(2, "0");

    return `${month}-${lastDay}`;
  };

  function EditToolbar(props) {
    const { setRows, setRowModesModel } = props;

    const handleClick = () => {
      const id = nanoid();
      const nextSLNO =
        rows.length > 0 ? Math.max(...rows.map((row) => row.SLNO || 0)) + 1 : 1;
      setRows((oldRows) => [
        ...oldRows,
        // {
        //   RecordID: id, // Temporary ID, replaced after backend save
        //   SLNO: nextSLNO,
        //   TaskID: "",
        //   TaskDetailRoleID: "",
        //   RoleCode: "",
        //   RoleName: "",
        //   TaskDetailEffort: 0,
        //   TaskDetailUnit: "",
        //   ProjectPlanedDate: "",
        //   isNew: true,
        // },
        {
          id: id,
          RecordID: id,
          Days: null,
          Department: null,
          Slots: null,
          Comments: "",
          isNew: true,
        }
      ]);
      setRowModesModel((oldModel) => ({
        ...oldModel,
        [id]: { mode: GridRowModes.Edit, fieldToFocus: "Days" },
      }));
    };
    return (
      <GridToolbarContainer
        sx={{
          marginBottom: "10px",
          display: "flex",
          justifyContent: "flex-start",
        }}
      >
        <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
          Add Record
        </Button>
      </GridToolbarContainer>
    );
  }

  const screenChange = async (event) => {
    setScreen(event.target.value);
    setRows([]);
    // if (event.target.value == "1") {
    //   const data = await dispatch(
    //     getTaskDetailListviewData({
    //       accessID: "TR237",
    //       screenName: "Task Detail",
    //       filter: `TaskID = ${recID}`,
    //       any: "",
    //       CompID: "",
    //     })
    //   );
    //   console.log("🚀 ~ screenChange ~ data:", data);
    //   if (data.payload.Status == "Y") {
    //     const resData = data.payload.Data.rows.map((value) => {
    //       return {
    //         ...value,
    //         TaskDetailRoleID: {
    //           RecordID: value.TaskDetailRoleID,
    //           Name: value.RoleName,
    //         },
    //       };
    //     });
    //     setRows(resData);
    //   } else {
    //     setRows([]); // Ensures rows don't break if explorelistViewData is undefined or not an array
    //   }
    // }
  };

  const handleSaveButtonClick = async (values, resetForm) => {


    const schedule = rows.map((row, index) => {
      return {
        DepartmentID: row.Department.RecordID || 0,
        SlotID: row.Slots.RecordID || 0,
        Day: row.Days.Name || "",
        Comments: row.Comments,

      };
    });

    console.log(schedule, "--handleSaveButtonClick schedule");
    // 🔹 Build full API structure
    const idata = {
      CompanyID: compID?.toString(),
      EmployeeID: values.empName?.RecordID || 0,
      ProjectID: values.ProName?.RecordID || 0,
      MileStoneID: values.Milestone?.map((item) => item.RecordID).join(",") || "",
      TermsID: values.Terms?.RecordID || 0,
      // FromDate: values.fromdate,
      // ToDate: values.todate,
      // FromDate: getFirstDateOfMonth(values.fromdate),
      // ToDate: getLastDateOfMonth(values.todate),
      Assignedby: EMPID,
      schedule: schedule,
    };

    console.log(data, "-- Final data");
    // return;
    try {
      const response = await dispatch(
        postData({
          accessID: "tr340",
          action: "insert",
          idata: idata,
        })
      );
      // const response = await dispatch(postData(payload));
      // Check response status for success
      if (response.payload.Status === "Y") {
        toast.success(response.payload.Msg);

        // ✅ Clear DataGrid
        // setRows([]);

        // // ✅ Reset Formik fields
        // resetForm();

      } else {
        toast.error(response.payload.Msg);
      }
    } catch (error) {
      toast.error("Error occurred during save.");
    }
  };
  return (
    <React.Fragment>
      {getLoading ? <LinearProgress /> : false}
      <Paper
        elevation={3}
        sx={{ margin: "0px 10px", background: "#F2F0F0", height: "50px" }}
      >
        <Box display="flex" justifyContent="space-between">
          <Box display="flex" borderRadius="3px" alignItems="center">
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Box
              display={isNonMobile ? "flex" : "none"}
              borderRadius="3px"
              alignItems="center"
            >
              {show == "0" ? (
                <Breadcrumbs
                  maxItems={3}
                  aria-label="breadcrumb"
                  separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                >

                  <Typography
                    variant="h5"
                    color="black"
                    sx={{
                      cursor: "default",
                      marginLeft: "10px",
                      fontSize: "19px",
                    }}
                  >
                    {mode === "E" || mode === "V" || mode === "IM" ? (is003Subscription ? `Task Allocation` : `Task`) : ""}

                    {mode === "TO" && mode !== "E" ? (
                      <Typography
                        variant="h5"
                        color="#0000D1"
                        sx={{ cursor: "default" }}
                      >
                        {is003Subscription ? `Task Allocation` : `Task`}
                        <Typography
                          variant="h5"
                          component="span"
                          sx={{
                            color: mode == "TO" ? "warning.main" : "text.primary",
                            fontWeight: 600,
                            marginLeft: 1,
                          }}
                        >
                          {mode == "TO" ? "-- Transfer" : ""}
                        </Typography>
                      </Typography>
                    ) : null}

                    {mode === "A" ? (is003Subscription ? `Task Allocation` : `Task`) : ""}
                    {mode === "S" || mode === "M" ? (is003Subscription ? `Task Allocation` : `Task`) : ""}
                  </Typography>

                </Breadcrumbs>
              ) : (
                false
              )}
              {show == "1" ? (
                <Breadcrumbs
                  maxItems={3}
                  aria-label="breadcrumb"
                  separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                >
                  <Typography
                    variant="h5"
                    color="black"
                    sx={{
                      cursor: "default",
                      marginLeft: "10px",
                      fontSize: "19px",
                      color:"#0000D1"
                    }}
                  >
                    Time Table
                  </Typography>
                </Breadcrumbs>
              ) : (
                false
              )}
            </Box>
          </Box>
          <Box display="flex">
            {mode !== "A" && is003Subscription && (

              <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                <InputLabel id="demo-select-small">Explore</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  value={show}
                  label="Explore"
                  onChange={screenChange}
                >
                  <MenuItem value={0}>Task Allocation</MenuItem>
                  <MenuItem value={1}>Time Table</MenuItem>
                </Select>
              </FormControl>
            )}
            <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>

      {show == "0" && !getLoading ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          {mode === "IM" && (
            <Box
              display="flex"
              padding={1}
              justifyContent="flex-end"
              mt="2px"
              gridColumn="span 4"
              gap={2}
              marginBottom={-5}
            >
              <IconButton
                onClick={() => setShowImage((prev) => !prev)}
                sx={{ padding: "12px" }}
              >
                <ArrowDownwardIcon
                  sx={{ color: "blue", marginBottom: "8px" }}
                />
              </IconButton>
            </Box>
          )}
          <Formik
            initialValues={dailyTaskInitialValue}
            onSubmit={(values, setSubmitting) => {
              setTimeout(() => {
                DTSaveFn(values);
              }, 100);
            }}
            validationSchema={validationSchema}
            enableReinitialize={true}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gridTemplateColumns="repeat(4 , minMax(0,1fr))"
                  gap={formGap}
                  padding={1}
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  {/* {QA == "N" ? ( */}

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gridColumn: "span 2",
                    }}
                  >
                    <CheckinAutocomplete
                      disabled={mode === "V" || mode == "TO"}
                      name="ProName"
                      label={
                        <>
                          Project
                          <span style={{ color: "red", fontSize: "20px" }}>
                            {" "}
                            *{" "}
                          </span>
                        </>
                      }
                      id="ProName"
                      value={values.ProName}
                      onChange={(newValue) => {
                        setFieldValue("ProName", newValue);
                        setFieldValue("empName", null);
                        setFieldValue("empCode", "");
                        setFieldValue("Milestone", null);
                        setFieldValue("OperationStage", null);
                        setFieldValue("Activities", null);
                      }}
                      error={!!touched.ProName && !!errors.ProName}
                      helperText={touched.ProName && errors.ProName}
                      url={`${listViewurl}?data={"Query":{"AccessID":"2119","ScreenName":"Project","Filter":"parentID=${compID} AND EmployeeID=${EMPID}","Any":""}}`}
                    // 2054
                    />

                    <Tooltip title={showMore ? "Close" : "Open"}>
                      <IconButton onClick={() => setShowMore((prev) => !prev)}>
                        {showMore ? <MoreHorizIcon /> : <MoreVertIcon />}
                      </IconButton>
                    </Tooltip>
                  </Box>
                  {showMore && (
                    <>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          gridColumn: "span 2",
                        }}
                      >
                        <CheckinAutocomplete
                          // sx={{ gridColumn: "span 2" }}
                          name="Milestone"
                          label="Milestone"
                          variant="outlined"
                          id="Milestone"
                          value={values.Milestone}
                          getOptionLabel={(option) => option?.Name || ""}
                          onChange={(newValue) => {
                            setFieldValue("Milestone", newValue);
                            // setSelectedMiles(newValue)
                          }}
                          url={`${listViewurl}?data={"Query":{"AccessID":"2105","ScreenName":"Milestone","Filter":"parentID IN(${values.ProName?.RecordID}) AND CompanyID='${compID}'","Any":""}}`}
                        />
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          gridColumn: "span 2",
                        }}
                      >
                        <CheckinAutocomplete
                          // sx={{ marginTop: "7px" }}
                          // sx={{ gridColumn: "span 2" }}
                          name="OperationStage"
                          label="Operation Stage"
                          variant="outlined"
                          id="OperationStage"
                          value={values.OperationStage}
                          onChange={(newValue) => {
                            setFieldValue("OperationStage", newValue);
                            // setSelectedOS(newValue)
                          }}
                          url={`${listViewurl}?data={"Query":{"AccessID":"2104","ScreenName":"Operation Stage","Filter":"parentID IN(${values.Milestone?.RecordID})","Any":""}}`}
                        />
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          gridColumn: "span 2",
                        }}
                      >
                        <CheckinAutocomplete
                          // sx={{ marginTop: "7px" }}
                          // sx={{ gridColumn: "span 2" }}
                          name="Activities"
                          label="Activities"
                          variant="outlined"
                          id="Activities"
                          value={values.Activities}
                          onChange={(newValue) => {
                            setFieldValue("Activities", newValue);
                            // setSelectedAct(newValue)
                          }}
                          url={`${listViewurl}?data={"Query":{"AccessID":"2103","ScreenName":"Activities","Filter":"parentID IN(${values.OperationStage?.RecordID})","Any":""}}`}
                        />
                      </Box>
                    </>
                  )}
                  {QA == "Y" ? (
                    <CheckinAutocomplete
                      disabled={mode === "V" || mode == "TO"}
                      sx={{ gridColumn: "span 2" }}
                      name="empName"
                      // label="Employee"
                      label={
                        <>
                          Personnel
                          <span style={{ color: "red", fontSize: "20px" }}>
                            {" "}
                            *{" "}
                          </span>
                        </>
                      }
                      id="empName"
                      key={values.ProName?.RecordID}
                      value={values.empName}
                      onChange={(newValue) => {
                        if (newValue) {
                          setFieldValue("empName", newValue);
                          setFieldValue("empCode", newValue.Code);
                        } else {
                          setFieldValue("empName", newValue);
                          setFieldValue("empCode", "");
                        }
                      }}
                      error={!!touched.empName && !!errors.empName}
                      helperText={touched.empName && errors.empName}
                      url={`${listViewurl}?data={"Query":{"AccessID":"2118","ScreenName":"EMPLOYEETEAMS","Filter":"ProjectID=${values.ProName?.RecordID} AND EmpID NOT IN (${EMPID}) GROUP BY RecordID","Any":"","CompId":${compID}}}`}
                    />
                  ) : (
                    <CheckinAutocomplete
                      disabled={mode === "V" || mode == "TO"}
                      sx={{ gridColumn: "span 2" }}
                      name="empName"
                      // label="Employee"
                      label={
                        <>
                          Personnel
                          <span style={{ color: "red", fontSize: "20px" }}>
                            {" "}
                            *{" "}
                          </span>
                        </>
                      }
                      id="empName"
                      value={values.empName}
                      onChange={(newValue) => {
                        if (newValue) {
                          setFieldValue("empCode", newValue.Code);
                          setFieldValue("empName", newValue);
                        } else {
                          setFieldValue("empCode", "");
                          setFieldValue("empName", newValue);
                        }
                      }}
                      error={!!touched.empName && !!errors.empName}
                      helperText={touched.empName && errors.empName}
                      url={`${listViewurl}?data=
                    {"Query":{"AccessID":"2101","ScreenName":"EMPLOYEETEAMS","Filter":"parentID=${EMPID} AND CompanyID ='${CompId}'","Any":"","CompId":${compID}}}`}
                    />
                  )}

                  <TextField
                    disabled={mode === "V" || mode == "TO"}
                    name="empCode"
                    type="text"
                    id="empCode"
                    label="Personnel Code"
                    variant="standard"
                    focused
                    value={values.empCode}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.empCode && !!errors.empCode}
                    helperText={touched.empCode && errors.empCode}
                    sx={{ gridColumn: "span 2", background: "" }}
                    inputProps={{ readOnly: true }}
                  />
                  <TextField
                    disabled={mode === "V" || mode == "TO"}
                    name="date"
                    type="date"
                    id="date"
                    label={
                      <>
                        Date
                        <span style={{ color: "red", fontSize: "20px" }}>
                          {" "}
                          *{" "}
                        </span>
                      </>
                    }
                    variant="standard"
                    inputFormat="DD-MM-YYYY"
                    focused
                    // required
                    value={values.date}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.date && !!errors.date}
                    helperText={touched.date && errors.date}
                    sx={{ gridColumn: "span 2", background: "" }}
                    InputLabelProps={{ shrink: true }}
                  />
                  <TextField
                    disabled={mode === "V" || mode == "TO"}
                    name="description"
                    type="text"
                    id="description"
                    // label="Description"
                    label={
                          <>
                            Title
                            <span style={{ color: "red", fontSize: "20px" }}>
                              {" "}
                              *{" "}
                            </span>
                          </>
                        }
                    variant="standard"
                    focused
                    value={values.description}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.description && !!errors.description}
                    helperText={touched.description && errors.description}
                    sx={{ gridColumn: "span 2" }}
                  />

                  {!showImage ? (
                    <React.Fragment>
                      <TextField
                        disabled={mode === "V" || mode == "TO"}
                        name="estimatedHours"
                        type="number"
                        id="estimatedHours"
                        // label="Estimated Hours"
                        label={
                          <>
                            Estimated Hours
                            <span style={{ color: "red", fontSize: "20px" }}>
                              {" "}
                              *{" "}
                            </span>
                          </>
                        }
                        multiline
                        // rows={6}
                        variant="standard"
                        fullWidth
                        focused
                        // required
                        value={values.estimatedHours}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          !!touched.estimatedHours && !!errors.estimatedHours
                        }
                        helperText={
                          touched.estimatedHours && errors.estimatedHours
                        }
                        sx={{ gridColumn: "span 2" }}
                        InputProps={{
                          sx: { textAlign: "right" },
                          inputProps: { style: { textAlign: "right" } },
                        }}
                      />
                      <TextField
                        disabled={mode === "V" || mode == "TO"}
                        name="actualHours"
                        type="number"
                        id="actualHours"
                        label="Actual Hours"
                        multiline
                        variant="standard"
                        fullWidth
                        focused
                        value={values.actualHours}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={!!touched.actualHours && !!errors.actualHours}
                        helperText={touched.actualHours && errors.actualHours}
                        sx={{ gridColumn: "span 2" }}
                        InputProps={{
                          readOnly: mode == "A" ? true : false,
                          sx: { textAlign: "right" },

                          inputProps: { style: { textAlign: "right" } },
                        }}
                      />
                      {/* <FormControl
                    // required
                    focused
                    variant="standard"
                    sx={{ gridColumn: "span 2" }}
                    disabled={
                      data.Status === "Approved" ||
                      mode === "C" ||
                      mode == "B" ||
                      mode === "UB" ||
                      mode === "V"
                    }
                    error={!!touched.TaskType && !!errors.TaskType}
                    helperText={touched.TaskType && errors.TaskType}
                  >
                    <InputLabel id="status3">{
                      <>
                        Type
                        <span style={{ color: "red", fontSize: "20px" }}> * </span>
                      </>
                    }</InputLabel> */}
                      <TextField
                        variant="standard"
                        type="text"
                        sx={{ gridColumn: "span 2" }}
                        disabled={
                          data.Status === "Approved" ||
                          mode === "C" ||
                          mode == "B" ||
                          mode === "UB" ||
                          mode === "V"
                        }
                        error={!!touched.TaskType && !!errors.TaskType}
                        helperText={touched.TaskType && errors.TaskType}
                        labelId="status3"
                        id="TaskType"
                        focused
                        label={
                          <>
                            Type
                            <span style={{ color: "red", fontSize: "20px" }}>
                              {" "}
                              *{" "}
                            </span>
                          </>
                        }
                        name="TaskType"
                        value={values.TaskType}
                        select
                        onBlur={handleBlur}
                        onChange={handleChange}
                      >
                        <MenuItem value="Normal">Normal</MenuItem>
                        <MenuItem value="Learning&development">
                          Learning & development
                        </MenuItem>
                        <MenuItem value="Research&development">
                          Research & development
                        </MenuItem>
                        <MenuItem value="Up-skill">Up-skill</MenuItem>
                        <MenuItem value="Bug">Bug</MenuItem>
                        <MenuItem value="Improvements">Improvements</MenuItem>
                        <MenuItem value="Script">Script</MenuItem>
                        <MenuItem value="Documentation">Documentation</MenuItem>
                      </TextField>
                      {/* </FormControl> */}
                      {/* <TextField
                        name="assignedBy"
                        type="text"
                        id="assignedBy"
                        label="Assigned By"
                        variant="standard"
                        focused
                        value={values.assignedPerson}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        sx={{ gridColumn: "span 2" }}
                        disabled
                      /> */}
                      <TextField
                        name="assignedPerson"
                        type="text"
                        id="assignedPerson"
                        label="Assigned By"
                        variant="standard"
                        focused
                        value={values.assignedPerson}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        sx={{ gridColumn: "span 2" }}
                        disabled
                      />
                      <TextField
                        name="assignedDate"
                        type="date"
                        id="assignedDate"
                        label="Assigned Date"
                        variant="standard"
                        focused
                        inputFormat="YYYY-MM-DD"
                        value={values.assignedDate}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        sx={{ gridColumn: "span 2" }}
                        InputLabelProps={{ shrink: true }}
                        disabled
                      />
                      <TextField
                        fullWidth
                        disabled={
                          data.Status === "Approved" ||
                          data.Status === "AP" ||
                          data.Status === "Completed"
                        }
                        name="TargetDate"
                        type="date"
                        id="TargetDate"
                        label={
                          <>
                            Target Date
                            <span style={{ color: "red", fontSize: "20px" }}>
                              {" "}
                              *{" "}
                            </span>
                          </>
                        }
                        variant="standard"
                        focused
                        format="MM-DD-YYYY"
                        value={values.TargetDate}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        sx={{ gridColumn: "span 2", background: "" }}
                        // required
                        error={!!touched.TargetDate && !!errors.TargetDate}
                        helperText={touched.TargetDate && errors.TargetDate}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: mode === "V" || mode === "TO",
                        }}
                        inputProps={{
                          min: targettoday, // ✅ prevents selecting past dates
                        }}
                      />
                      {/* <FormControl
                    // required
                    focused
                    variant="standard"
                    sx={{ gridColumn: "span 2" }}
                    disabled={
                      data.Status === "Approved" ||
                      mode === "C" ||
                      mode == "B" ||
                      mode === "UB" ||
                      mode === "V"
                    }
                   
                  >
                    <InputLabel id="status2">
                      <>
                        Priority
                        <span style={{ color: "red", fontSize: "20px" }}> * </span>
                      </>
                    </InputLabel> */}
                      <TextField
                        variant="standard"
                        type="text"
                        focused
                        sx={{ gridColumn: "span 2" }}
                        label={
                          <>
                            Task Priority
                            <span style={{ color: "red", fontSize: "20px" }}>
                              {" "}
                              *{" "}
                            </span>
                          </>
                        }
                        disabled={
                          data.Status === "Approved" ||
                          mode === "C" ||
                          mode == "B" ||
                          mode == "UB" ||
                          mode === "V"
                        }
                        labelId="status2"
                        id="TaskPriority"
                        name="TaskPriority"
                        value={values.TaskPriority}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.TaskPriority && !!errors.TaskPriority}
                        helperText={touched.TaskPriority && errors.TaskPriority}
                        select
                      >
                        <MenuItem value="Low">Low</MenuItem>
                        <MenuItem value="Medium">Medium</MenuItem>
                        <MenuItem value="High">High</MenuItem>
                      </TextField>
                      {/* </FormControl> */}
                      <FormControl
                        disabled={mode === "V" || mode == "TO"}
                        focused
                        variant="standard"
                        sx={{ gridColumn: "span 2" }}
                      >
                        <InputLabel id="status">Status</InputLabel>
                        <Select
                          disabled={mode === "V" || mode == "TO"}
                          labelId="demo-simple-select-filled-label"
                          id="status"
                          name="status"
                          // value={values.status}
                          value={mode == "TO" ? "T" : values.status}
                          onBlur={handleBlur}
                          onChange={handleChange}
                        >
                          {values.status !== "C" && (
                            <MenuItem value="AS">Assigned</MenuItem>
                          )}
                          <MenuItem value="C">Completed</MenuItem>
                          {/* {values.status == "C" && (<MenuItem value="AP">Approved</MenuItem>)} */}
                          {(values.status == "C" || values.status === "AP") && (
                            <MenuItem value="AP">Approved</MenuItem>
                          )}
                          {data.TaskSource != "Self" && mode == "E" && (
                            <MenuItem value="B">Blocked</MenuItem>
                          )}
                          {values.status !== "C" && (
                            <MenuItem value="I">Inprogress</MenuItem>
                          )}
                          {(mode == "TO" || values.status == "T") && (
                            <MenuItem value="T">Transfer</MenuItem>
                          )}
                          {/* {values.status == "C" && (<MenuItem value="RJ">Rejected</MenuItem>)} */}
                          {(values.status === "C" ||
                            values.status === "RJ") && (
                              <MenuItem value="RJ">Rejected</MenuItem>
                            )}
                        </Select>
                      </FormControl>{" "}
                    </React.Fragment>
                  ) : (
                    false
                  )}
                </Box>
                {!showImage ? (
                  <Box padding={1}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <TextField
                          disabled={mode === "V"}
                          name="Comment"
                          type="text"
                          id="Comment"
                          label={
                            <>
                              Comments
                              <span style={{ color: "red", fontSize: "20px" }}>
                                {" "}
                                *{" "}
                              </span>
                            </>
                          }
                          multiline
                          rows={4}
                          variant="outlined"
                          fullWidth
                          focused
                          // required

                          value={values.Comment}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={!!touched.Comment && !!errors.Comment}
                          helperText={touched.Comment && errors.Comment}
                          sx={{ gridColumn: "span 2" }}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        {/* {mode === "E" */}
                        {values.status == "RJ" ||
                          values.status == "AP" ||
                          mode === "M" ? (
                          <TextField
                            disabled={mode === "V"}
                            name="ManagerComments"
                            type="text"
                            id="ManagerComments"
                            label={"Manager Comments"}
                            multiline
                            rows={4}
                            variant="outlined"
                            fullWidth
                            focused
                            // required

                            value={values.ManagerComments}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            sx={{ gridColumn: "span 2" }}
                          />
                        ) : (
                          false
                        )}
                        <Stack spacing={2}>
                          {values.status === "T" || mode == "TO" ? (
                            <Employeeautocomplete
                              disabled={mode === "V"}
                              sx={{ gridColumn: "span 2" }}
                              name="employee"
                              label="Transfer To Personnel"
                              id="employee"
                              value={values.employee}
                              onChange={(newValue) => {
                                setFieldValue("employee", newValue);
                              }}
                              url={`${listViewurl}?data={"Query":{"AccessID":"2121","ScreenName":"EMPLOYEETEAMS","Filter":"parentID=${EMPID} AND ProjectID=${values?.ProName?.RecordID}","Any":"","CompId":${compID}}}`}
                            />
                          ) : (
                            false
                          )}

                          {values.status == "T" || mode == "TO" ? (
                            <TextField
                              name="empDate"
                              type="date"
                              id="empDate"
                              label="Transfer To Date"
                              // inputFormat="YYYY-MM-DD"
                              variant="standard"
                              focused
                              value={values.empDate}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              sx={{ gridColumn: "span 2" }}
                            />
                          ) : (
                            false
                          )}
                        </Stack>
                      </Grid>
                    </Grid>
                  </Box>
                ) : (
                  false
                )}
                <Box
                  display="flex"
                  justifyContent="end"
                  mt="20px"
                  gap="20px"
                  padding={1}
                >
                  {mode == "IM" && (
                    <>
                      <TextField
                        name="purpose"
                        type="text"
                        id="purpose"
                        label="Purpose"
                        variant="standard"
                        focused
                        value={values.purpose}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.purpose && !!errors.purpose}
                        helperText={touched.purpose && errors.purpose}
                        sx={{ gridColumn: "span 2", height: "20px" }}
                        InputLabelProps={{ shrink: true }}
                      />

                      <Box display="flex" alignItems="center" gap={1}>
                        <FileUploadIconButton
                          onFileSelect={(file) => {
                            fileUpload(
                              file,
                              values.empName.RecordID
                                ? values.empName.RecordID
                                : 0,
                              "upload",
                              "",
                              values.purpose ? values.purpose : "",
                            );
                            setFieldValue("purpose", "");
                          }}
                        />
                      </Box>
                    </>
                  )}
                  <LoadingButton
                    disabled={mode === "V" || mode === "IM"}
                    color="secondary"
                    variant="contained"
                    type="submit"
                    loading={isLoading}
                  >
                    Save
                  </LoadingButton>

                  <Button
                    color="warning"
                    variant="contained"
                    // onClick={() => {
                    //   navigate(
                    //     `/Apps/Secondarylistview/TR263/Tasks/${EMPID}`
                    //   );
                    // }}
                    onClick={() => {
                      if (params.Mode === "M" || params.Mode === "S") {
                        navigate(-1);
                      } else {
                        navigate(
                          is003Subscription ? `/Apps/Secondarylistview/TR353/Tasks/${EMPID}` :
                            `/Apps/Secondarylistview/TR263/Tasks/${EMPID}`,
                        );
                      }
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
                {Array.isArray(files) && mode === "IM" && files.length > 0 ? (
                  <Box mt={2}>
                    <Paper elevation={3} sx={{ padding: 2 }}>
                      <TableContainer component={Paper}>
                        <Table size="small">
                          <TableHead>
                            <TableRow sx={rowSx}>
                              <TableCell width={20}>
                                <strong>SL#</strong>
                              </TableCell>
                              <TableCell>
                                <strong>Uploaded Date</strong>
                              </TableCell>
                              <TableCell>
                                <strong>Filename</strong>
                              </TableCell>
                              <TableCell>
                                <strong>Purpose</strong>
                              </TableCell>
                              <TableCell>
                                <strong>Source</strong>
                              </TableCell>
                              <TableCell>
                                <strong>View</strong>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {files.length === 0 ? (
                              <TableRow>
                                <TableCell colSpan={4} align="center">
                                  No files uploaded yet.
                                </TableCell>
                              </TableRow>
                            ) : (
                              files.map((file, index) => (
                                <TableRow key={file.id || index} sx={rowSx}>
                                  <TableCell>{index + 1}</TableCell>
                                  <TableCell>{file.uploadedDate}</TableCell>
                                  <TableCell>{file.filename}</TableCell>
                                  <TableCell>{file.purpose}</TableCell>
                                  <TableCell>{file.source}</TableCell>
                                  <TableCell>
                                    <Tooltip title="Open File">
                                      <IconButton
                                        color="primary"
                                        component="a"

                                        href={is003Subscription ? `${baseurl1}uploads/images/${file.filename}` : file.url}
                                        // href={file.url}
                                        // href={`${baseurl1}uploads/images/${file.filename}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        size="small"
                                      >
                                        <OpenInNewIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip title="delete">
                                      <IconButton
                                        color="error"
                                        onClick={() =>
                                          fileUpload(
                                            file.filename,
                                            values.empName.RecordID
                                              ? values.empName.RecordID
                                              : 0,
                                            "delete",
                                            file.id,
                                            file.purpose,
                                          )
                                        }
                                        size="small"
                                      >
                                        <DeleteForeverIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                  </TableCell>
                                </TableRow>
                              ))
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Paper>
                  </Box>
                ) : null}
              </form>
            )}
          </Formik>

          <FileListPopup
            open={open}
            onClose={() => setOpen(false)}
            appId={recID}
            empId={EMPID}
          />
        </Paper>
      ) : (
        false
      )}

      {show == "1" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={TimeTableInitialValue}
            onSubmit={(values, { resetForm }) => {
              handleSaveButtonClick(values, resetForm);
            }}
            //  initialValues={dailyTaskInitialValue}
            // onSubmit={(values, setSubmitting) => {
            //   setTimeout(() => {

            //     DTSaveFn(values);
            //   }, 100);
            // }}
            // validationSchema={validationSchema}
            enableReinitialize={true}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gridTemplateColumns="repeat(4 , minMax(0,1fr))"
                  gap={formGap}
                  padding={1}
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gridColumn: "span 2",
                    }}
                  >
                    <CheckinAutocomplete
                      disabled={mode === "V" || mode == "TO"}
                      name="ProName"
                      label={
                        <>
                          {/* Project */}
                          Standards
                          <span style={{ color: "red", fontSize: "20px" }}>
                            {" "}
                            *{" "}
                          </span>
                        </>
                      }
                      id="ProName"
                      value={values.ProName}
                      onChange={(newValue) => {
                        setFieldValue("ProName", newValue);
                      }}
                      error={!!touched.ProName && !!errors.ProName}
                      helperText={touched.ProName && errors.ProName}
                      url={`${listViewurl}?data={"Query":{"AccessID":"2119","ScreenName":"Project","Filter":"parentID=${compID} AND EmployeeID=${EMPID}","Any":""}}`}
                    // 2054
                    />
                  </Box>
                  {/* <CheckinAutocomplete
                          sx={{ gridColumn: "span 1" }}
                          name="Milestone"
                          // label="Milestone"
                          // label="Sections"
  label={
                        <>
                          Sections
                          <span style={{ color: "red", fontSize: "20px" }}>
                            {" "}
                            *{" "}
                          </span>
                        </>
                      }
                          variant="outlined"
                          id="Milestone"
                          value={values.Milestone}
                          getOptionLabel={(option) => option?.Name || ""}
                          onChange={(newValue) => {
                            setFieldValue("Milestone", newValue);
                            // setSelectedMiles(newValue)
                          }}
                          url={`${listViewurl}?data={"Query":{"AccessID":"2105","ScreenName":"Milestone","Filter":"parentID IN(${values.ProName?.RecordID}) AND CompanyID='${compID}'","Any":""}}`}
                        /> */}
                  <MultiFormikOptimizedAutocomplete
                    sx={{ gridColumn: "span 2" }}
                    name="Milestone"
                    // label="Milestone"
                    // label="Sections"
                    label={
                      <>
                        Sections
                        <span style={{ color: "red", fontSize: "20px" }}>
                          {" "}
                          *{" "}
                        </span>
                      </>
                    }
                    variant="outlined"
                    id="Milestone"
                    value={values.Milestone}
                    // getOptionLabel={(option) => option?.Name || ""}
                    // onChange={(newValue) => {
                    //   setFieldValue("Milestone", newValue);
                    //   // setSelectedMiles(newValue)
                    // }}
                    onChange={(e, newValue) =>
                      setFieldValue("Milestone", newValue)
                    }
                    url={`${listViewurl}?data={"Query":{"AccessID":"2105","ScreenName":"Milestone","Filter":"parentID IN(${values.ProName?.RecordID}) AND CompanyID='${compID}'","Any":""}}`}
                  />

                  <CheckinAutocomplete
                    disabled={mode === "V" || mode == "TO"}
                    sx={{ gridColumn: "span 2" }}
                    name="empName"
                    // label="Employee"
                    label={
                      <>
                        Personnel
                        <span style={{ color: "red", fontSize: "20px" }}>
                          {" "}
                          *{" "}
                        </span>
                      </>
                    }
                    id="empName"
                    value={values.empName}
                    onChange={(newValue) => {
                      if (newValue) {
                        setFieldValue("empCode", newValue.Code);
                        setFieldValue("empName", newValue);
                      } else {
                        setFieldValue("empCode", "");
                        setFieldValue("empName", newValue);
                      }
                    }}
                    error={!!touched.empName && !!errors.empName}
                    helperText={touched.empName && errors.empName}
                    url={`${listViewurl}?data=
                    {"Query":{"AccessID":"2101","ScreenName":"EMPLOYEETEAMS","Filter":"parentID=${EMPID} AND CompanyID ='${CompId}'","Any":"","CompId":${compID}}}`}
                  />


                  <CheckinAutocomplete

                    sx={{ gridColumn: "span 2" }}
                    name="Terms"
                    label={
                      <>
                        Terms
                        <span style={{ color: "red", fontSize: "20px" }}>
                          {" "}
                          *{" "}
                        </span>
                      </>
                    }
                    id="Terms"
                    value={values.Terms}
                    onChange={(newValue) => {
                      if (newValue) {
                        setTermsIDPas(newValue.RecordID);
                        console.log(termsIDPass, "--termsIDPass");
                        setFieldValue("TermsCode", newValue.Code);
                        setFieldValue("Terms", newValue);
                      } else {
                        setFieldValue("TermsCode", "");
                        setFieldValue("Terms", newValue);
                      }
                    }}
                    error={!!touched.Terms && !!errors.Terms}
                    helperText={touched.Terms && errors.Terms}
                    url={`${listViewurl}?data=
                    {"Query":{"AccessID":"2155","ScreenName":"Terms","Filter":"","Any":"","CompId":${compID}}}`}
                  />
                  {/* <TextField
                    disabled={mode === "V" || mode == "TO"}
                    name="fromdate"
                    type="month"
                    id="fromdate"
                    label={
                      <>
                        From Period
                        <span style={{ color: "red", fontSize: "20px" }}>
                          {" "}
                          *{" "}
                        </span>
                      </>
                    }
                    variant="standard"
                    inputFormat="DD-MM-YYYY"
                    focused
                    // required
                    value={values.fromdate}
                    onBlur={handleBlur}
                    onChange={handleChange}
//                    onChange={(e) => {
//   console.log(e.target.name,values.fromdate, "e.target.value");
//   handleChange(e);
// }}
                    error={!!touched.fromdate && !!errors.fromdate}
                    helperText={touched.fromdate && errors.fromdate}
                    sx={{ gridColumn: "span 2", background: "" }}
                    InputLabelProps={{ shrink: true }}
                  />
                  <TextField
                    disabled={mode === "V" || mode == "TO"}
                    name="todate"
                    type="month"
                    id="todate"
                    label={
                      <>
                        To Period
                        <span style={{ color: "red", fontSize: "20px" }}>
                          {" "}
                          *{" "}
                        </span>
                      </>
                    }
                    variant="standard"
                    inputFormat="DD-MM-YYYY"
                    focused
                    // required
                    value={values.todate}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.todate && !!errors.todate}
                    helperText={touched.todate && errors.todate}
                    sx={{ gridColumn: "span 2", background: "" }}
                    InputLabelProps={{ shrink: true }}
                  /> */}

                  {/* <TextField
                    disabled={mode === "V" || mode == "TO"}
                    name="fromdate"
                    type="date"
                    id="fromdate"
                    label={
                      <>
                        From Date
                        <span style={{ color: "red", fontSize: "20px" }}>
                          {" "}
                          *{" "}
                        </span>
                      </>
                    }
                    variant="standard"
                    inputFormat="DD-MM-YYYY"
                    focused
                    // required
                    value={values.fromdate}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.fromdate && !!errors.fromdate}
                    helperText={touched.fromdate && errors.fromdate}
                    sx={{ gridColumn: "span 2", background: "" }}
                    InputLabelProps={{ shrink: true }}
                  />
                  <TextField
                    disabled={mode === "V" || mode == "TO"}
                    name="todate"
                    type="date"
                    id="todate"
                    label={
                      <>
                        To Date
                        <span style={{ color: "red", fontSize: "20px" }}>
                          {" "}
                          *{" "}
                        </span>
                      </>
                    }
                    variant="standard"
                    inputFormat="DD-MM-YYYY"
                    focused
                    // required
                    value={values.todate}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.todate && !!errors.todate}
                    helperText={touched.todate && errors.todate}
                    sx={{ gridColumn: "span 2", background: "" }}
                    InputLabelProps={{ shrink: true }}
                  /> */}

                  <Box sx={{ gridColumn: "span 4" }}>
                    <Box
                      height="500px"
                      // height={dataGridHeight}
                      marginTop={2}
                      sx={{
                        "& .MuiDataGrid-root": {
                          // border: "none",
                        },
                        "& .MuiDataGrid-cell": {
                          // borderBottom: "none",
                        },
                        "& .name-column--cell": {
                          color: colors.greenAccent[300],
                        },
                        "& .MuiDataGrid-columnHeaders": {
                          backgroundColor: colors.blueAccent[800],
                          // borderBottom: "none",
                        },
                        "& .MuiDataGrid-virtualScroller": {
                          backgroundColor: colors.primary[400],
                        },
                        "& .MuiDataGrid-footerContainer": {
                          // borderTop: "none",
                          backgroundColor: colors.blueAccent[800],
                        },
                        "& .MuiCheckbox-root": {
                          color: `${colors.greenAccent[200]} !important`,
                        },
                        "& .odd-row": {
                          backgroundColor: "",
                          color: "", // Color for odd rows
                        },
                        "& .even-row": {
                          backgroundColor: "#d0edec",
                          color: "", // Color for even rows
                        },
                      }}
                    >
                      <DataGrid
                        sx={{
                          "& .MuiDataGrid-footerContainer": {
                            height: dataGridHeaderFooterHeight,
                            minHeight: dataGridHeaderFooterHeight,
                          },
                        }}
                        rowHeight={dataGridRowHeight}
                        headerHeight={dataGridHeaderFooterHeight}
                        rows={rows}
                        columns={TTColumns}
                        editMode="row"
                        disableSelectionOnClick
                        rowModesModel={rowModesModel}
                        onRowModesModelChange={handleRowModesModelChange}
                        onRowEditStop={handleRowEditStop}
                        processRowUpdate={processRowUpdate}
                        getRowId={(row) => row.RecordID}

                        disableRowSelectionOnClick
                        experimentalFeatures={{ newEditingApi: true }}
                        onProcessRowUpdateError={(error) => {
                          console.error(
                            "Row update validation failed:",
                            error.message,
                          );

                          toast.error(error.message);
                        }}
                        components={{
                          Toolbar: EditToolbar,
                        }}
                        componentsProps={{
                          toolbar: { setRows, setRowModesModel },
                        }}
                        rowsPerPageOptions={[5, 10, 20]}
                        getRowClassName={(params) =>
                          params.indexRelativeToCurrentPage % 2 === 0
                            ? "odd-row"
                            : "even-row"
                        }
                        pagination
                        pageSize={pageSize}
                        page={page}
                        onPageSizeChange={(newPageSize) =>
                          setPageSize(newPageSize)
                        }
                        onPageChange={(newPage) => setPage(newPage)}
                      />
                    </Box>
                  </Box>
                </Box>

                <Box
                  display="flex"
                  justifyContent="end"
                  mt="20px"
                  gap="20px"
                  padding={1}
                >
                  <LoadingButton
                    disabled={mode === "V" || mode === "IM"}
                    color="secondary"
                    variant="contained"
                    //  onClick={() => handleSaveButtonClick(values)}
                    type="submit"

                    loading={isLoading}
                  >
                    Generate
                  </LoadingButton>

                  <Button
                    color="warning"
                    variant="contained"
                    // onClick={() => {
                    //   navigate(
                    //     `/Apps/Secondarylistview/TR263/Tasks/${EMPID}`
                    //   );
                    // }}
                    onClick={() => {
                      if (params.Mode === "M" || params.Mode === "S") {
                        navigate(-1);
                      } else {
                        setScreen(0);
                        //  navigate(-1);
                        // navigate(
                        //   `/Apps/Secondarylistview/TR263/Tasks/${EMPID}`,
                        // );
                      }
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Paper>
      ) : (
        false
      )}
    </React.Fragment>
  );
};

export default EditDailytaskListEdit;
